import { VEHICLE_AVAILABILITIES } from 'constants/vehicleStatuses.constants';
import { RecordOf } from 'immutable';
import { createSelector } from 'reselect';
import { RootState } from 'store';

/*
 * Top selector for the vehicles state
 */
const selectVehiclesState = (state: RecordOf<RootState>) => state.get('vehicles');

/*
 * Follow-on selectors for the vehicles state
 */
export const selectActiveTab = () => createSelector(selectVehiclesState, (substate) => substate.get('activeTab'));

export const selectActiveView = () => createSelector(selectVehiclesState, (substate) => substate.get('activeView'));

export const selectCalendarStart = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('calendarStart'));

export const selectColumns = () => createSelector(selectVehiclesState, (substate) => substate.get('columns'));

export const selectDepartments = () => createSelector(selectVehiclesState, (substate) => substate.get('departments'));

export const selectErrors = () => createSelector(selectVehiclesState, (substate) => substate.get('errors'));

export const selectFilters = () => createSelector(selectVehiclesState, (substate) => substate.get('filters'));

export const selectHistory = () => createSelector(selectVehiclesState, (substate) => substate.get('history'));

export const selectLoading = () => createSelector(selectVehiclesState, (substate) => substate.get('loading'));

export const selectLoadingLightVehicles = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('loadingLightVehicles'));

export const selectLoadingVehicles = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('loadingVehicles'));

export const selectOffset = () => createSelector(selectVehiclesState, (substate) => substate.get('offset'));

export const selectPerPage = () => createSelector(selectVehiclesState, (substate) => substate.get('perPage'));

export const selectRefreshFuelLoading = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('refreshFuelLoading'));

export const selectRefreshOdometerLoading = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('refreshOdometerLoading'));

export const selectRefreshBatteryLoading = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('refreshBatteryLoading'));

export const selectSearchQuery = () => createSelector(selectVehiclesState, (substate) => substate.get('searchQuery'));

export const selectStatuses = () => createSelector(selectVehiclesState, (substate) => substate.get('statuses'));

export const selectTotal = () => createSelector(selectVehiclesState, (substate) => substate.get('total'));

export const selectVehicle = () => createSelector(selectVehiclesState, (substate) => substate.get('vehicle'));

export const selectVehicleDamages = () => createSelector(selectVehicle(), (substate) => substate.get('damages'));

export const selectVehicles = () => createSelector(selectVehiclesState, (substate) => substate.get('vehicles'));

export const selectVehiclesMap = () => createSelector(selectVehiclesState, (substate) => substate.get('vehiclesMap'));

export const selectViews = () => createSelector(selectVehiclesState, (substate) => substate.get('views'));

export const selectIsVehicleAvailable = () =>
  createSelector(
    selectVehicle(),
    (substate) => substate.get('availability') === Number(VEHICLE_AVAILABILITIES.AVAILABLE.id)
  );

export const selectDashboardVehicles = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('dashboardVehicles'));

export const selectLoadingDashboardVehicles = () =>
  createSelector(selectVehiclesState, (substate) => substate.get('loadingDashboardVehicles'));

export const selectDashboardVehicleByVin = (vin: string) =>
  createSelector(selectVehiclesState, (substate) =>
    vin ? substate.getIn(['dashboardVehicles', vin.toUpperCase()]) : undefined
  );
